import { pxToRem } from "@/util";
import {
  Box,
  // Typography,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import SearchIcon from "@mui/icons-material/Search";
// import Image from "next/image";
import { AppColors } from "@/assets/colors";

export default function TagSearch() {
  const { classes } = styles();
  // console.log("TagSearch data:", data);

  return (
    <Box className={`${classes.container} `}>
      {/* <Box className={classes.tagBox}>
        <Typography className={classes.tagHeading}>Tags:</Typography>

        <Box className={classes.tagsContainer}>
          {data?.tags?.map((tag, index) => (
            <Typography key={index} className={classes.tag}>
              {tag}
            </Typography>
          ))}
        </Box>
      </Box> */}

      <Box className={classes.searchSection}>
        {" "}
        <Box className={classes.submitCont}>
          <TextField
            placeholder="Search for Blog"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            className={classes.emailInput}
            sx={{ input: textFieldStyleInput }}
          />
          <Button className={classes.submitBtn} variant="contained">
            Search
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const textFieldStyleInput = {
  color: AppColors.text.second,
  height: "100%",
};

const styles = makeStyles()((theme) => ({
  submitCont: {
    display: "flex",
    flexDirection: "row",
    height: pxToRem(50),
  },
  submitBtn: {
    width: pxToRem(95),
    height: pxToRem(50),
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: pxToRem(8),
    borderBottomRightRadius: pxToRem(8),
  },
  emailInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      height: "100%",
      borderTopLeftRadius: pxToRem(8),
      borderBottomLeftRadius: pxToRem(8),
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      "& fieldset": {
        borderColor: AppColors.neutral[65],
      },
      "&:hover fieldset": {
        borderColor: AppColors.primary[500],
      },
      "&.Mui-focused fieldset": {
        borderColor: AppColors.primary[400],
      },
      "&.Mui-disabled fieldset": {
        borderColor: AppColors.neutral[30],
      },
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
     // display: "none",
    },
  },
  tagHeading: {
    fontSize: pxToRem(16),
    fontWeight: 600,
    lineHeight: "160%",
    color: AppColors.primary["600"],
    // fontFamily: "Playfair Display",
  },

  searchSection: {
    margin: `${pxToRem(30)} ${pxToRem(0)} `,
  },
  searchCont: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: pxToRem(50),
    //overflow:'clip'
  },

  searchBtn: {
    //width: "80%",
    height: pxToRem(50),
    display: "flex",
  },
}));
